<template>
    <PerDialog
        :config="config"
        @closePerDialog="closePerDialog"
        @confirmPerDialog="confirmPerDialog"
        @before-close="closePerDialog"></PerDialog>
</template>

<script>
import PerDialog from './Person';
import { getPersonage } from './api/strategicManage';
export default {
    components: { PerDialog },
    props: {
        checkPerStatus: {
            type: Object
        }
    },
    data() {
        return {
            config: {
                title: '添加成员',
                showDialog: false,
                selectList: [],
                value: '',
                tree: {
                    key: 'code',
                    defaultProps: {
                        children: 'children',
                        label: 'name'
                    }
                },
                operation: [
                    {
                        label: '取 消',
                        Event: 'closePerDialog'
                    },
                    {
                        label: '确 定',
                        Event: 'confirmPerDialog',
                        type: 'primary'
                    }
                ]
            }
        };
    },
    methods: {
        closePerDialog() {
            this.config.showDialog = false;
            this.$emit('closePerDialog', { open: false });
        },
        confirmPerDialog(data) {
            if (data.selectList.length === 0) {
                this.$message.warning('请选择成员');
                return;
            }
            this.config.showDialog = false;
            this.$emit('perDialog', { open: false, index: this.checkPerStatus.openIndex, checklist: data.selectList });
        },
        judgeOpen() {
            if (this.checkPerStatus.showDialog === true) {
                this.config.showDialog = true;
            }
        }
    },
    mounted() {
        this.judgeOpen();
        this.checkPerStatus.checkedList.forEach(e => {
            const params = {
                userCode: e.userCode
            };
            getPersonage(params).then(res => {
                if (+res.code === 0) {
                    const a = res.data.list[0];
                    a.isCheck = true;
                    this.config.selectList.push(a);
                }
            });
        });
    }
};
</script>
<style lang="less">
    #person-dialog {
        .dialog-body {
            width: 100%;
            height: 444px;
        }
        .el-dialog__body {
            padding: 0;
            border-bottom: 1px solid #E6E6E6;
        }
        .data-show {
            margin-left: 16px;
            padding-top: 16px;
            padding-right: 10px;
            float: left;
            height: 100%;
            width: 70%;
            border-right: 1px solid #E6E6E6;
            box-sizing: border-box;

            .structure-tree.el-tree {
                margin-top: 10px;
                height: calc(100% - 50px);
                width: 40%;
                box-sizing: border-box;
                overflow: auto;
                border-right: 1px solid #E6E6E6;
            }
        }
        .checked-list {
            margin: 0 16px 16px 10px;
            padding-top: 16px;
            height: 100%;
            width: 25%;
            float: left;
            box-sizing: border-box;
        }
        .checked-list-title {
            width: 100%;
            height: 40px;
            background-color: #F2F2F2;
            line-height: 38px;
            color: #666666;
            padding: 0 10px 0 20px;
            box-sizing: border-box;
        }
        .checked-num i {
            font-style: normal;
            color: #3EA4EB;
        }
        .clear-all {
            float: right;
            cursor: pointer;
        }
        .checked-every {
            width: 100%;
            height: 38px;
            line-height: 38px;
            color: #666666;
            padding: 0 10px 0 20px;
            box-sizing: border-box;
        }
        .checked-every:hover {
            background-color: #F0F8FA;
        }
        .checked-every span:last-child{
            float: right;
            cursor: pointer;
            color: #AAAAAA;
            font-size: 18px;
        }
        .checked-items {
            width: 100%;
            overflow: auto;
        }
        .data-search {
            background-color: #F2F2F2;
            height: 40px;
            width: 100%;
            line-height: 40px;
            padding: 0 5px 0 10px;
            box-sizing: border-box;
        }
        .data-search span:first-child {
            color: #666666;
            font-size: 14px;
            float: left;
        }
        .data-search .el-input {
            width: 45%;
            float: right;
        }
    }
</style>
